import React, { useRef, useEffect, useState } from "react";

const getYoutubeId = (url) => {
    const regExp = /(?:youtube\.com.*(?:\?|&)v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regExp);
    return match ? match[1] : null;
};

const YoutubePlayer = ({ url, onProgress, onComplete,watch_time }) => {
    const playerRef = useRef(null);
    const [player, setPlayer] = useState(null);
    const [duration, setDuration] = useState(0);

    const seekTo = (seconds) => {
        if (player && typeof player.seekTo === "function") {
            player.seekTo(seconds, true);
        }
    };

    useEffect(()=>{
        if (player && typeof watch_time === 'number' && watch_time > 0) {
            seekTo(watch_time);
        }
    },[player,watch_time])
    useEffect(() => {
        // Load YouTube IFrame API
        if (!window.YT) {
            const tag = document.createElement("script");
            tag.src = "https://www.youtube.com/iframe_api";
            document.body.appendChild(tag);
        } else {
            loadPlayer();
        }

        window.onYouTubeIframeAPIReady = loadPlayer;

        function loadPlayer() {
            if (player) return;
            const videoId = getYoutubeId(url);
            if (!videoId) return;
            const ytPlayer = new window.YT.Player(playerRef.current, {
                videoId,
                events: {
                    onReady: (e) => {
                        setDuration(e.target.getDuration());
                    },
                    onStateChange: (e) => {
                        if (e.data === window.YT.PlayerState.ENDED && onComplete) {
                            onComplete();
                        }
                    },
                },
            });
            setPlayer(ytPlayer);
        }

        return () => {
            if (player) {
                player.destroy();
            }
        };
        // eslint-disable-next-line
    }, [url]);

    useEffect(() => {
        let interval;
        if (player) {
            interval = setInterval(() => {
                const currentTime = player.getCurrentTime ? player.getCurrentTime() : 0;
                if (onProgress && duration) {
                    onProgress(currentTime, duration);
                }
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [player, duration, onProgress]);

    return (
        <div>
            <div ref={playerRef}></div>
        </div>
    );
};

export default YoutubePlayer;